import { useState } from "react";
import {
  Button,
  Spin,
  Alert,
  Card,
  Pagination,
  Divider,
  AutoComplete
} from "antd";
import { getStoryById } from "./api";
import { AsyncRequest } from "use-async-request";
import styled from "styled-components";

const Loading = styled.div`
  display: flex;
  min-height: 100px;
  align-items: center;
  justify-content: center;
`;

const Story = ({ data }) => {
  const list = (data && data[0] && Object.values(data[0]).slice(0, 10)) || [];
  const [storyId, setStoryId] = useState(list[0]);

  const StorySuccess = ({ data, refetch }) => {
    const { title = "", url = "", by = "" } = data?.[0];
    return (
      <Card
        title={
          <>
            by: <strong>{by}</strong>
          </>
        }
        style={{ width: 300, margin: "0 auto" }}
      >
        <a href={url}>{title}</a>
        <Divider />
        <p>
          <Button onClick={() => refetch()}>refetch</Button>
        </p>
      </Card>
    );
  };

  return (
    <>
      <AsyncRequest
        requestFunctions={[
          {
            func: getStoryById,
            payload: { storyId }
          }
        ]}
        success={StorySuccess}
        loading={
          <Spin spinning>
            <Loading />
          </Spin>
        }
        error={({ error, refetch }) => (
          <>
            <Alert
              message={
                <>
                  {error.message}
                  <Button onClick={() => refetch()} size="small">
                    refetch
                  </Button>
                </>
              }
              type="error"
              showIcon
            />
          </>
        )}
      />
      <Pagination
        style={{ marginTop: 10 }}
        defaultCurrent={1}
        pageSize={1}
        total={list.length}
        onChange={(page, _) => setStoryId(list[page - 1])}
      />
    </>
  );
};

export default Story;
